import { log } from '../webUtils'
import { setActiveTreeItem } from '../actions/'
import { enigmaResetFieldsStatus, enigmaSolved, enigmaInvalidAttempt, closeEnigma } from '../actions/enigmaActions'
import { setFilesStatus } from '../actions/mediaActions'
import { isValidMulti } from '../helpers/enigmas.helper'

const unlockItem = (enigma, action, isForced = false) => {
  console.warn('unlockItem deprecated')
  if (enigma.unlockType && enigma.unlockId) {
    switch (enigma.unlockType) {
      case 'FILETREE':
        action.asyncDispatch(setFilesStatus(enigma.unlockId), 'UNLOCKED')
        if (!isForced) {
          action.asyncDispatch(setActiveTreeItem(enigma.unlockId))
        }
        break;
      default:
        console.error('Unrecognized unlockType: ', enigma)
    }
  }
}

const enigmas = (state = [], action) => {
  switch (action.type) {
    case 'ADD_ENIGMA':
      var id = Math.max(0, ...state.map(f => f.id)) + 1;
      return [
        ...state,
        {
          id: id,
          question: action.question,
          answer: action.answer,
          validMessage: action.validMessage,
          invalidMessage: action.invalidMessage,
          language: action.language,
          activityId: action.activityId,
        }
      ]
    case 'CHANGE_ENIGMA':
      return state.map(enigma => {
        if (enigma.id === action.id) {
          var newEnigma = { ...enigma };
          newEnigma[action.name] = action.value;
          return newEnigma;
        }
        return enigma;
      })
    case 'OPEN_ENIGMA':
      var enigma = state.find(({ id }) => id == action.id);
      // Si ça a déjà été validé, on dévérouille la cible dans le doute
      if (enigma.status == 'VALID' && enigma.unlockType && enigma.unlockId) {
        unlockItem(enigma, action);
      }
      return state;
    case 'ENIGMA_RESET_FIELDS_STATUS':
      return state.map(enigma => {
        if (enigma.id == action.id) {
          return {
            ...enigma, status: action.status, fields: enigma.fields?.map(field => {
              if (field.status != 'VALID')
                return { ...field, status: 'DEFAULT' }
              else
                return field;
            })
          }
        }
        return enigma
      })
    case 'CLT_MISSION_CLOSE_SESSION':
      return state.map(enigma => ({ ...enigma, isSolved: false, status: 'DEFAULT' }))
    case 'SUBMIT_ENIGMA_ANSWER':
      return state.map(enigma => {
        if (enigma.id == action.id) {
          var newEnigma = isValidMulti(action.answer, enigma);
          if (newEnigma.status == 'VALID') {
            action.asyncDispatch(enigmaSolved(enigma.id));  // Send server
            // Autoclose
            if (enigma.autoCloseValid) {
              action.asyncDispatch(closeEnigma(enigma.id))
            }
            return newEnigma;
          }
          else {
            action.asyncDispatch(enigmaInvalidAttempt(enigma.id));
            if (enigma.autoCloseInvalid) {
              action.asyncDispatch(closeEnigma(enigma.id))
            }
            setTimeout(() => action.asyncDispatch(enigmaResetFieldsStatus(enigma.id)), 2000);
            return newEnigma
          }
        }
        return enigma
      })
    case 'FORCE_ENIGMA_STATUS':
      return state.map(enigma => {
        if (typeof action.id == 'number') {
          if (enigma.id == action.id) {
            return { ...enigma, status: action.status }
          }
        }
        else if (action.id?.includes(enigma.id)) {
          return { ...enigma, status: action.status };
        }
        return enigma;
      })
    case 'PUSH_ENIGMA_SOLVED':
      // TODO
      return state;
    case 'DELETE_ENIGMA':
      return state.filter(({ id }) => id !== action.id);
    case 'PUSH_ACTIVITY_CONTENT':
      if (typeof action.data.enigmas == 'undefined') {
        log('Undefined data.enigmas from server.')
        return state;
      }
      else
        return action.data.enigmas;
    case 'SET_STATE_FROM_DATABASE':
      if (typeof action.state.enigmas === 'undefined') {
        log('Undefined "state.enigmas" from server.')
        return state;
      }
      else
        return action.state.enigmas;
    default:
      return state
  }
}

export default enigmas
